import Icon from "@/components/Icon"
import ExistingDocuments from "@/components/documents/ExistingDocuments"
import BootstrapButton from "@/components/form/BootstrapButton"
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons"
import { Teleport, computed, ref } from "vue"
import { Modal, defineComponent, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../../IncidentLogHandler"
import UploadDocuments from "./UploadDocuments"

const IncidentDocuments: ReactiveComponent = () => {
	const handler = useIncidentHandler()
	const documents = computed(() => (handler.incident.incidentDocuments ? [...handler.incident.incidentDocuments] : []))

	const uploadingDocs = ref(false)

	return () => (
		<div class="flex flex-col spacing-4">
			<ExistingDocuments documents={documents.value} />
			{!handler.readOnly && (
				<div>
					<BootstrapButton color="success" onClick={() => (uploadingDocs.value = true)}>
						<Icon icon={faPlusCircle} />
						<span>Upload a new document</span>
					</BootstrapButton>
				</div>
			)}
			{uploadingDocs.value && !handler.readOnly && (
				<Teleport to="body">
					<Modal zIndex={4} class="flex flex-col" style={{ width: "56rem", height: "32rem" }}>
						<UploadDocuments
							cancel={() => (uploadingDocs.value = false)}
							onUploaded={() => (uploadingDocs.value = false)}
						/>
					</Modal>
				</Teleport>
			)}
		</div>
	)
}

export default defineComponent(IncidentDocuments)
